import { render, staticRenderFns } from "./ChangePasswordStudent.vue?vue&type=template&id=ce6a77c4"
import script from "../../services/student/change-password-student.js?vue&type=script&lang=js&external"
export * from "../../services/student/change-password-student.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports